import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { header } from 'app/_misc/headers';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor(private httpClient: HttpClient) { }      

  loginUser(formData: FormData) {
    return this.httpClient.post('/login/login', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => {       
      return response.body; 
    }), catchError(this.handleError));
  }

  validateLoginInformation(formData: FormData) {
    return this.httpClient.post('/login/validatelogininformation', formData, {
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body;
    }), catchError(this.handleError));
  }  

  resetPassword(formData: FormData) {
    return this.httpClient.post('/login/resetpassword', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }

  forgotPassword(formData: FormData) {
    return this.httpClient.post('/login/forgotpassword', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }

  validateToken(formData: FormData) {
    return this.httpClient.post('/login/validatetoken', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }

  resetForgotPassword(formData: FormData) {
    return this.httpClient.post('/login/resetforgotpassword', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }

  loginFromMicrosoft(formData: FormData) {
    return this.httpClient.post('/login/loginfrommicrosoft', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }

  handleError(error: any) { return throwError(error); }
}